export const sovetov = {
  id: 'sovetov',
  name: {
    ru: 'Советов Мерхат Мұратұлы',
    kz: 'Советов Мерхат Мұратұлы',
  },
  position: {
    ru: 'Врач-реабилитолог отделения физиотерапии, лечебной физкультуры и массажа',
    kz: 'Физиотерапия, емдік дене шынықтыру және массаж бөлімінің дәрігер-реабилитологы',
  },
  department: 'physiotherapy',
  image: '/team_photoes/new/sovetov.png',
  experience: {
    ru: 'Резидентура: 01.09.2024–24.07.2026',
    kz: 'Резидентура: 01.09.2024–24.07.2026',
  },
  education: {
    ru: `01.09.2024–24.07.2026 — Резидентура по специальности «Реабилитология»`,
    kz: `01.09.2024–24.07.2026 — «Реабилитология» мамандығы бойынша резидентура`,
  },
  work: {
    ru: `• 01.09.2024 — 24.07.2026 — Резидентура по специальности «Реабилитология»`,
    kz: `• 01.09.2024 — 24.07.2026 — «Реабилитология» мамандығы бойынша резидентура`,
  },
};
